<template>
  <div>
    <CameraTestBase
        @stream="onStream"
        @previewVideo="onPreviewVideo"
    ></CameraTestBase>
    <canvas style="position: absolute; left: 0px; top: 0px; pointer-events: none;"
            ref="landmarkCvs"
    ></canvas>

    <div>
      <div>
        <button @click="loadMediaPipe(!MediaPipe.run)">{{!MediaPipe.run ? 'run' : 'stop'}} mediapipe</button>
        <label class="info"
           v-if="MediaPipe.created"
        ><span>created</span><span>{{MediaPipe.created}}ms</span></label>
        <select v-model="MediaPipe.detectTermMs">
          <option
              v-for="ms in MediaPipe.detectTermMsList" :key="ms"
              :value="ms"
          >{{ms}}ms({{(1000/ms).toFixed(1)}}frame)</option>
        </select>
        <select v-model="MediaPipe.runningMode">
          <option value="VIDEO">VIDEO</option>
          <option value="IMAGE">IMAGE</option>
        </select>
        <span :style="{color: MediaPipe.detected ? '' : 'red'}">detect: {{MediaPipe.detected}}</span>
      </div>
      <div>
        <label>
          <input type="checkbox" v-model="MediaPipe.drawLandmark">
          <span>draw landmark</span>
        </label>
        <label>
          <input type="checkbox" v-model="MediaPipe.showLandmarkParts">
          <span>show landmark parts</span>
        </label>
      </div>

      <div style="font-size: 12px;"
           v-if="MediaPipe.showLandmarkParts"
      >
        * body parts: {{MediaPipe.shownBodyParts}}
        <br>
        * landmarks details: {{MediaPipe.shownLandmarks}}
      </div>
    </div>

    <div style="display: none;">
      <button @click="startImageSegmenter">create ImageSegmenter</button>
      <button @click="imageSegmentForVideo">imageSegmente for video</button>
      <button @click="imageSegmentForImage">imageSegmente for video</button>
    </div>
    <div>
      <button @click="loadImageSegmenter(!ImageSegment.run)">{{!ImageSegment.run ? 'run' : 'stop'}} ImageSegment</button>
      <label class="info"
             v-if="ImageSegment.created"
      ><span>created</span><span>{{ImageSegment.created}}ms</span></label>
      <select v-model="ImageSegment.detectTermMs">
        <option
            v-for="ms in ImageSegment.detectTermMsList" :key="ms"
            :value="ms"
        >{{ms}}ms({{(1000/ms).toFixed(1)}}frame)</option>
      </select>
      <span :style="{color: ImageSegment.detected ? '' : 'red'}">detect: {{ImageSegment.detected}}</span>
      <span v-if="ImageSegment.lastDetected">, {{ImageSegment.lastDetected}}</span>
    </div>

    <div>
      <canvas v-show="SelfieSegmentation.drawMask" style="display: none;position: absolute; left: 0px; top: 0px; pointer-events: none;"
              ref="selfiSegmentationCvs"
      ></canvas>
      <button @click="loadSelfieSegmentation(!SelfieSegmentation.run)">{{!SelfieSegmentation.run ? 'run' : 'stop'}} SelfieSegmentation</button>
      <label class="info"
             v-if="SelfieSegmentation.created"
      ><span>created</span><span>{{SelfieSegmentation.created}}ms</span></label>
      <select v-model="SelfieSegmentation.detectTermMs">
        <option
            v-for="ms in SelfieSegmentation.detectTermMsList" :key="ms"
            :value="ms"
        >{{ms}}ms({{(1000/ms).toFixed(1)}}frame)</option>
      </select>
      <label>
        <input type="checkbox" v-model="SelfieSegmentation.worker">
        <span>worker</span>
      </label>
      <label>
        <input type="checkbox" v-model="SelfieSegmentation.drawMask">
        <span>draw mask</span>
      </label>
      <span :style="{color: SelfieSegmentation.detected ? '' : 'red'}">, detect:{{SelfieSegmentation.detected}}</span>
      <span>, rate:{{SelfieSegmentation.personRate}}%</span>
      <span v-if="SelfieSegmentation.lastDetected">, {{SelfieSegmentation.lastDetected}}</span>
    </div>
  </div>
</template>

<script>
import CameraTestBase from "@/components/test/camera/CameraTestBase.vue";
import GrmPoseLandmarker from "@/lib/gooroomee/mediapipe/pose-landmarker/grm-poseLandmarker";
import GrmImageSegmenter from "@/lib/gooroomee/mediapipe/image-segmenter/grm-imageSegmenter";
import GrmSelfieSegmentationFactory from "@/lib/gooroomee/mediapipe/selfie-segmentation/grm-selfieSegmentation-factory";

export default {
  name: 'PoseLandmarkerTest',
  components: {CameraTestBase},
  data() {
    return {
      stream: null,
      video: null,
      MediaPipe: {
        created: null,
        runningMode: 'VIDEO',
        run: false,
        detected: false,
        drawLandmark: true,
        detectTermMs: 1000,
        detectTermMsList: (() => {
          const list = [5, 10, 50, 65, 100, 300, 500, 700, 1000, 1500, 2000, 3000, 5000, 1000 * 60 * 60];
          [60, 30, 20, 10, 5, 1].map(n => parseInt(1000 / n))
              .forEach(n => {
                if (!list.includes(n)) {
                  list.push(n);
                }
              });
          return list.sort((a, b) => a - b);
        })(),
        showLandmarkParts: true,
        shownLandmarks: '',
        shownBodyParts: ''
      },
      ImageSegment: {
        created: null,
        run: false,
        detected: false,
        lastDetected: null,
        detectTermMs: 1000,
        detectTermMsList: (() => {
          const list = [5, 10, 50, 65, 100, 300, 500, 700, 1000, 1500, 2000, 3000, 5000, 1000 * 60 * 60];
          [60, 30, 20, 10, 5, 1].map(n => parseInt(1000 / n))
              .forEach(n => {
                if (!list.includes(n)) {
                  list.push(n);
                }
              });
          return list.sort((a, b) => a - b);
        })(),
      },
      SelfieSegmentation: {
        created: null,
        worker: true,
        run: false,
        detected: false,
        personRate: 0,
        drawMask: false,
        lastDetected: null,
        detectTermMs: 1000,
        detectTermMsList: (() => {
          const list = [5, 10, 50, 65, 100, 300, 500, 700, 1000, 1500, 2000, 3000, 5000, 1000 * 60 * 60];
          [60, 30, 20, 10, 5, 1].map(n => parseInt(1000 / n))
              .forEach(n => {
                if (!list.includes(n)) {
                  list.push(n);
                }
              });
          return list.sort((a, b) => a - b);
        })(),
      },
    }
  },
  watch: Object.assign({},
      (() => {
        const watchList = {};
        ['runningMode', 'run', 'drawLandmark', 'detectTermMs'].forEach(key => {
          watchList[`MediaPipe.${key}`] = function(value, old){
            if(!this.grmPoseLandmarker || !this.grmPoseLandmarker.result) return;
            const result = this.grmPoseLandmarker.result;
            switch(key){
              case 'runningMode':
                // if(this.grmPoseLandmarker){
                //   this.grmPoseLandmarker.setLandmarkerOptions({runningMode: value});
                // }
                break;
              case 'run':
                if(value) result.resume()
                else result.pause()
                break;
              case 'drawLandmark':
                result.setDrawLandmark(value);
                break;
              case 'detectTermMs':
                result.changeDetectIntervalMs(value);
                break;
            }
          }
        });
        return watchList;
      })(),
      (() => {
        const watchList = {};
        ['run', 'detectTermMs'].forEach(key => {
          watchList[`ImageSegment.${key}`] = function(value, old){
            if(!this.grmImageSegmenter || !this.grmImageSegmenter.result) return;
            console.log('change:', `ImageSegment.${key}`)
            const result = this.grmImageSegmenter.result;
            switch(key){
              case 'run':
                if(value) result.resume()
                else result.pause()
                break;
              case 'detectTermMs':
                result.changeDetectIntervalMs(value);
                break;
            }
          }
        })
        return watchList;
      })(),
      (() => {
        const watchList = {};
        ['run', 'worker', 'detectTermMs'].forEach(key => {
          watchList[`SelfieSegmentation.${key}`] = function(value, old){
            if(!this.grmSelfieSegmentation || !this.grmSelfieSegmentation.result) return;
            console.log('change:', `ImageSegment.${key}`)
            const result = this.grmSelfieSegmentation.result;
            switch(key){
              case 'run':
                if(!value){
                  result.destroy();
                }
                break;
              case 'worker':
                this.grmSelfieSegmentation.options.useImageUtilsWorker = value;
                break;
              case 'detectTermMs':
                result.changeDetectIntervalMs(value);
                break;
            }
          }
        })
        return watchList;
      })(),
  ),
  created () {
    window.$vp = this;
    console.log('vue created')
  },
  methods: {
    onStream ({stream}) {
      this.stream = stream;
    },
    onPreviewVideo (video) {
      this.video = video;
      video.parentElement.append(this.$refs.landmarkCvs);
    },

    async loadMediaPipe (run) {
      const {video} = this;
      if(!video) return;

      if(run === false){
        this.MediaPipe.run = false;
        return;
      }
      this.MediaPipe.run = true;

      const PL = this.grmPoseLandmarker = this.grmPoseLandmarker || await (async () => {
        this.GrmPoseLandmarker = GrmPoseLandmarker;

        let st = Date.now();
        const pl = new GrmPoseLandmarker({
          poseLandmarker: {
            runningMode: this.MediaPipe.runningMode || 'VIDEO',
            baseOptions: {
              // modelAssetPath: 'full'
            }
          }
        });
        await pl.init();
        this.MediaPipe.created = Date.now() - st;
        console.log('# GrmPoseLandmarker created : %dms', this.MediaPipe.created);
        return pl;
      })();
      // if(PL.result){
      //   PL.result.destroy();
      // }
      PL.detectForVideo({
        video,
        landmarkCanvas: this.$refs.landmarkCvs,
        detectIntervalMs: this.MediaPipe.detectTermMs,
        debugTime: true,
        callback: result => {
          PL.result = result;
          this.MediaPipe.detected = result.detected;

          if(this.MediaPipe.showLandmarkParts){
            if(result.detected){
              const pData = result.parseData;
              // const arr = GrmPoseLandmarker.LANDMARK_UTILS.getShownLandmarkIdxList(result.data.landmarks[0]);
              // this.MediaPipe.shownLandmarks = GrmPoseLandmarker.LANDMARK_UTILS.getLandmarkNames(arr).join(',');
              // this.MediaPipe.shownLandmarks = GrmPoseLandmarker.LANDMARK_UTILS.getLandmarkNames(arr).join(',');
              this.MediaPipe.result = pData;
              // this.MediaPipe.shownLandmarks = arr.map(d => d.name).join(',');
              // this.MediaPipe.shownBodyParts = GrmPoseLandmarker.LANDMARK_UTILS.getBodyPartNames(arr.map(d => d.idx))
              //                                   .map(part => part.name).join(',')

              this.MediaPipe.shownLandmarks = pData.map(d => d.name).join(',');
              this.MediaPipe.shownBodyParts = `[${pData.rect.total.percent}%]` + `${pData.wholeBody ? `[wholeBody]` : ''}`
                                                + Object.keys(pData.rect.bodyParts).join(',');
            }else{
              this.MediaPipe.shownLandmarks = '';
              this.MediaPipe.shownBodyParts = '';
            }
          }
        }
      })
    },

    async startImageSegmenter () {
      if(this.grmImageSegmenter) return;

      this.GrmImageSegmenter = GrmImageSegmenter;
      let st = Date.now();
      const app = this.grmImageSegmenter = new GrmImageSegmenter({
        imageSegmenter: {
          runningMode: 'VIDEO',
        }
      });
      await app.init();
      console.log('# imageSegmenter created: %sms', Date.now()-st);
    },
    async imageSegmentForVideo () {
      if(!this.grmImageSegmenter) return;
      let st = Date.now();
      let result = await this.grmImageSegmenter.segmentForVideo(this.video);
      console.log('# imageSegmenter 1: %sms', Date.now()-st, result);
    },
    async imageSegmentForImage () {
      if(!this.grmImageSegmenter) return;
      let st = Date.now();
      let result = await this.grmImageSegmenter.segment(this.video);
      console.log('# imageSegmenter 2: %sms', Date.now()-st, result);
    },

    async loadImageSegmenter (run) {
      const {video} = this;
      if(!video) return;

      if(run === false){
        this.ImageSegment.run = false;
        return;
      }
      this.ImageSegment.run = true;

      const PL = this.grmImageSegmenter = this.grmImageSegmenter || await (async () => {
        this.GrmImageSegmenter = GrmImageSegmenter;

        let st = Date.now();
        const pl = new GrmImageSegmenter({
          imageSegmenter: {
            runningMode: 'VIDEO',
          }
        });
        await pl.init();
        this.ImageSegment.created = Date.now() - st;
        console.log('# GrmImageSegment created : %dms', this.ImageSegment.created);
        return pl;
      })();

      PL.segmentMonitorForVideo({
        video,
        detectIntervalMs: this.ImageSegment.detectTermMs,
        callback: result => {
          this.grmImageSegmenter.result = result;

          this.ImageSegment.detected = result.data.hasPerson
          const now = new Date();
          this.ImageSegment.lastDetected = now.toLocaleString() + '.' + now.getMilliseconds()
        }
      })
    },

    async loadSelfieSegmentation (run) {
      const {video} = this;
      if(!video) return;

      const config = this.SelfieSegmentation;

      if(run === false){
        config.run = false;
        return;
      }
      config.run = true;

      const PL = this.grmSelfieSegmentation = this.grmSelfieSegmentation || await (async () => {
        // this.GrmSelfieSegmentation = GrmSelfieSegmentation;

        let st = Date.now();
        const pl = GrmSelfieSegmentationFactory.create({
          selfieSegmentation: {
          }
        });
        await pl.init();
        config.created = Date.now() - st;
        console.log('# GrmSelfieSegmentation created : %dms', config.created);
        return pl;
      })();

      const {selfiSegmentationCvs} = this.$refs;
      selfiSegmentationCvs._ctx = selfiSegmentationCvs._ctx = selfiSegmentationCvs.getContext('2d');
      video.parentElement.append(selfiSegmentationCvs);
      selfiSegmentationCvs.style.display = '';

      PL.detectMonitorForVideo({
        video,
        detectIntervalMs: config.detectTermMs,
        onMask: mask => {
          if(!config.drawMask){
            return;
          }

          Object.assign(selfiSegmentationCvs, {
            width: video.videoWidth,
            height: video.videoHeight,
          });
          if(mask){
            if(mask.width > 0 && mask.height > 0){
              selfiSegmentationCvs._ctx.drawImage(
                  mask, 0, 0,
                  selfiSegmentationCvs.width, selfiSegmentationCvs.height
              );
            }
          }
        },
        callback: result => {
          PL.result = result;

          config.detected = result.data.hasPerson;
          config.personRate = (result.data.parseData?.rate*100).toFixed(2);
          const now = new Date();
          config.lastDetected = now.toLocaleString() + '.' + now.getMilliseconds()
        }
      })
    },
  } // end of methods
}
</script>

<style scoped lang="scss">

</style>